import ArrowButtonHome from "~/assets/icons/ArrowButtonHome";
import { smallBannerHome } from "../../../setup/settings/index";

export function SmallBannerHome() {
  return (
    <div className="smallBannerHome__container">
      <p className='smallBannerHome__title'>{smallBannerHome.h3}</p>
      <p className='smallBannerHome__subtitle'>{smallBannerHome.subtitle}</p>
      <a className="smallBannerHome__btn" href={`${smallBannerHome.href}`}><button>{smallBannerHome.textButton}</button><ArrowButtonHome /></a>
    </div>
  );
};